


























import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator';
import {
  getAutoScrollDistance,
  getOverflowState,
  getScrollState,
  ScrollerState,
  NavTabsInfo,
} from './business';

/**
 * 导航分类切换
 */
@Component
export default class NavTabs extends Vue {
  @Ref('container') container!: HTMLElement;
  @Ref('tabBottom') tabBottom!: HTMLElement;
  /**
   * 分类列表项
   */
  @Prop({ default: () => [] }) public list!: NavTabsInfo[];
  /**
   * 列表项距离2端的距离(px)（小于这个距离会认为是靠边，点击该项后会自动滚动列表，使其展示更多隐藏内容）
   */
  @Prop({ default: 40 }) public scrollOffset!: number;
  /**
   *  列表每次自动滚动（矫正）的距离(px)
   */
  @Prop({ default: 120 }) public scrollDistance !: number;
  /**
   * 是否禁用
   */
  @Prop({ default: false }) public disabled!: boolean;
  /**
   *  是否等分布局
   */
  @Prop({ default: false }) public spaceAround!: boolean;

  /**
   * 当前滚动条状态
   */
  scrollState = [ScrollerState.Start];

  /**
   * 动画线条样式参数
   */
  lineStyleObj = {
    pos: 0,
    width: 0,
  };

  /**
   * 选项内容超过导航可视区域标示
   */
  isOverflowX = true;

  /**
   * 分类列表
   */
  dataList: NavTabsInfo[] = [];

  /**
   * 滚动条是否在最左侧
   */
  get isAtStart() {
    return this.scrollState.includes(ScrollerState.Start);
  }

  /**
   * 滚动条是否在最右侧
   */
  get isAtEnd() {
    return this.scrollState.includes(ScrollerState.End);
  }

  /**
   * 底部动画区域样式
   */
  get lineStyle() {
    const { pos, width } = this.lineStyleObj;
    return {
      transform: `translateX(${pos}px)`,
      width: `${width}px`,
    };
  }

  /**
   * 监听prop传入的数据列表变化，重新更新列表项目
   */
  @Watch('list')
  initData() {
    this.dataList = [];
    if (this.list.length > 0) {
      const data = JSON.parse(JSON.stringify(this.list)) as NavTabsInfo[];
      // 如果列表中没有指定选中项，则选中第一项
      if (!data.find(item => item.actived)) {
        data[0].actived = true;
      }
      this.dataList = data;
      this.swtichToNewTab();
    }
  }

  /**
   * 设置选中项选中动画
   */
  setNavTabActived() {
    const [el] = this.container.getElementsByClassName('actived');
    if (el) {
      // 滚动列表，展示更多隐藏区域选项
      this.adjustTabPos(el as HTMLElement);
    }
  }

  /**
   * 点击2侧的分类项，自动调整分类列表滚动位置，确保用户能看到更多隐藏信息
   */
  adjustTabPos(el: HTMLElement) {
    const { container, scrollOffset, scrollDistance } = this;
    if (this.container) {
      const distance = getAutoScrollDistance(el, container, scrollOffset, scrollDistance);
      if (distance !== 0) {
        this.container.scrollBy({ left: distance });
      }
      this.adjustTabBottomPos(el);
    }
  }

  /**
   * 调整底部横线栏目位置
   * @param el
   */
  adjustTabBottomPos(el: HTMLElement) {
    const { tabBottom } = this;
    if (tabBottom) {
      const { left, width } = el.getBoundingClientRect();
      const parentLeft = this.container.getBoundingClientRect().left;
      const { scrollLeft } = this.container;
      // 设置选中项底部横线位置及动画
      Object.assign(this.lineStyleObj, {
        pos: scrollLeft + left - parentLeft,
        width,
      });
    }
  }

  /**
   * 切换到新的tab
   * @param navTab
   */
  swtichToNewTab() {
    this.$nextTick(() => {
      const actived = this.dataList.find(item => item.actived);
      // 设置选中项选中动画
      this.setNavTabActived();
      this.$emit('change', actived);
    });
  }

  /**
   * 点击切换分类
   */
  handleSwitch(navTab: NavTabsInfo) {
    if (!this.disabled && !navTab.actived) {
      const tab = this.dataList.find(item => item.actived);
      tab && (tab.actived = false);
      this.$set(navTab, 'actived', true);
      this.swtichToNewTab();
    }
  }

  /**
   * 监测列表滚动行为，控制右侧遮罩蒙层展示
   */
  handleScroll() {
    this.scrollState = getScrollState(this.container);
  }

  /**
   * 切换到指定ID的分类项
   * @param id 项ID
   */
  switchNavTab(id: string) {
    const navTab = this.dataList.find(item => item.id === id);
    navTab && this.handleSwitch(navTab);
  }

  created() {
    this.initData();
  }

  mounted() {
    this.isOverflowX = getOverflowState(this.container).isOverflowX;
    this.handleScroll();
  }
}
